import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const SolarInstallation = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my solar installation business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps solar installation businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for solar installation businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most solar installation businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my solar installation business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like solar installation. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Solar Installation - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Solar Installation CRM", url: "/industries/solar-installation" }
  ];

  const industryData = {
    name: 'Solar Installation',
    title: 'Nurture Leads Through Long Sales Cycles & Close More Deals',
    subtitle: 'Automate educational content delivery, track ROI calculations, and stay top-of-mind until customers are ready',
    icon: '☀️',
    challenges: [
      'Long sales cycles - leads go cold',
      'Complex ROI calculations confuse customers',
      'Hard to follow up on all quotes',
      'Rebate/incentive changes affect timing',
      'Post-install referrals are missed'
    ],
    solutions: [
      'Long-term lead nurture automation',
      'ROI calculator and tracking',
      'Smart quote follow-up sequences',
      'Incentive deadline alerts',
      'Referral program automation'
    ],
    features: [
      'Lead CRM with engagement tracking',
      'ROI calculator tool',
      'Educational drip campaigns',
      'Quote tracking and follow-up',
      'Incentive monitoring',
      'Installation scheduling',
      'Post-install checkup automation',
      'Referral program'
    ],
    results: [
      '55% more leads convert',
      '40% shorter sales cycle',
      '3x more referral installations',
      '£19.5K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Solar Installation UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for solar installation businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for solar installation UK, solar installation business software, solar installation customer management, solar installation lead generation UK"
        url="/industries/solar-installation"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default SolarInstallation;